import Component from '../vendor/Component'

export default class ProductDescriptionMore extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this.selectors = {
      truncated: '[data-product-description-more-el="truncated"]',
      full: '[data-product-description-more-el="full"]',
      open: '[data-product-description-more-el="open"]',
      close: '[data-product-description-more-el="close"]'
    }

    this.truncatedEl = this._elem.querySelector(this.selectors.truncated)
    this.fullEl = this._elem.querySelector(this.selectors.full)
    this.openEl = this._elem.querySelector(this.selectors.open)
    this.closeEl = this._elem.querySelector(this.selectors.close)
  }

  async mount() {
    this.setupListeners()
  }

  setupListeners() {
    this.openEl.addEventListener('click', this.handleReadMoreClick.bind(this))
    this.closeEl.addEventListener('click', this.handleReadLessClick.bind(this))
  }

  handleReadMoreClick() {
    this.truncatedEl.style.display = 'none'
    this.openEl.style.display = 'none'
    this.fullEl.style.display = 'block'
    this.closeEl.style.display = 'block'
    
    this._elem.dispatchEvent(
      new CustomEvent('product:readMoreToggle', { bubbles: true })
    )

    // Analytics
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'pdp_read_more_click'
    })
  }
  
  handleReadLessClick() {
    this.truncatedEl.style.display = 'inline'
    this.openEl.style.display = 'block'
    this.fullEl.style.display = 'none'
    this.closeEl.style.display = 'none'

    this._elem.dispatchEvent(
      new CustomEvent('product:readMoreToggle', { bubbles: true })
    )
  }
}